import { TestType } from "@app/provider/testData/types";

const TEST_TYPES = [TestType.PANORAMA, TestType.HORIZON];

export const getBusinessRuleEngineType = (
  testType?: TestType,
  nevaSessionToken?: string
): string | undefined => {
  if (!testType || !TEST_TYPES.includes(testType)) return undefined;
  return nevaSessionToken ? "new" : "old";
};
